module.exports = __webpack_public_path__ + "static/media/data-center-mainframe-icon_2-color.d207b0aa.svg";